import { render, staticRenderFns } from "./CancellationRefundAmounts.vue?vue&type=template&id=4fb7d9c9&scoped=true&"
import script from "./CancellationRefundAmounts.vue?vue&type=script&lang=js&"
export * from "./CancellationRefundAmounts.vue?vue&type=script&lang=js&"
import style0 from "./CancellationRefundAmounts.vue?vue&type=style&index=0&id=4fb7d9c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7d9c9",
  null
  
)

export default component.exports